import { toNumber, toString } from 'lodash';

import { ALL_OPTION } from '@/common/constants';
import { OptionKey } from '@/common/types';
import { getTaxYears } from '@/utils/handlers';

export const areAmountsValidBySum = (
  employeeContributionAmount?: string,
  employerContributionAmount?: string
) => toNumber(employeeContributionAmount) + toNumber(employerContributionAmount) > 0;

export const isVersionControlErrorText = (errorText?: string) =>
  errorText?.includes('modified by another user') ?? false;

export const PER_PAGE = [10, 20, 50, 100];
export const PER_PAGE_OPTIONS = PER_PAGE.map((item) => ({
  key: item,
  value: item,
  title: toString(item),
}));
export const DEFAULT_OPTIONS = [ALL_OPTION.value];

export const allTaxYears = getTaxYears();
export const taxYearOptions = [
  ALL_OPTION,
  ...allTaxYears.map((value) => ({ key: value, value, title: value })),
];

export const MAX_RECORDS_TO_UPDATE = 2000;
export const DEFAULT_PER_PAGE = 10;
export const DEFAULT_PAGE = 1;
export const PAGE_STEP = 1;

export const ACTIVE_PLAN_STATUS = 'ACTIVE';

export const allValuesToggling = (values: OptionKey[], allLength: number) => {
  const isAllSelected =
    values?.[values.length - 1] === ALL_OPTION.value ||
    (!values?.some((value) => value === ALL_OPTION.value) && values.length === allLength - 1);

  if (values.length === 0 || isAllSelected) {
    return DEFAULT_OPTIONS;
  }

  const isAllChangedToAnother = values.length === 2 && values[0] === ALL_OPTION.value;

  if (isAllChangedToAnother) {
    return values.filter((val) => val !== ALL_OPTION.value);
  }

  return values;
};
